"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_CONFIG = void 0;
var DEFAULT_CONFIG = {
  hotels: {
    gutm: '&utm_source=airasia_web&utm_medium=search_widget&utm_campaign=SAH&utm_content=en-GB',
    mobilegutm: '&utm_source=airasia_mobileapp&utm_medium=search_widget&utm_campaign=SAH&utm_content=en-GB',
    AAA: "https://www.airasiago.com.my/lp/dailydeals?langid=2057",
    TWD: 'https://www.expedia.com.tw/lp/dailydeals?langid=1033',
    MYR: 'https://www.airasiago.com.my/lp/dailydeals?langid=2057',
    IDR: 'https://www.airasiago.co.id/lp/dailydeals?langid=2057',
    SGD: 'https://www.airasiago.com.sg/lp/dailydeals?langid=2057',
    HKD: 'https://www.airasiago.com.hk/lp/dailydeals?langid=2057',
    AUD: 'https://www.airasiago.com.au/lp/dailydeals?langid=2057',
    KRW: 'https://www.airasiago.com.my/lp/dailydeals?langid=2057',
    CNY: 'https://www.airasiago.com.my/lp/dailydeals?langid=2057',
    THB: 'https://thailand.airasiago.com/lp/dailydeals?langid=2057',
    PHP: 'https://www.expedia.com.ph/lp/dailydeals?langid=2057',
    JPY: 'https://www.airasiago.jp/lp/dailydeals?langid=1033',
    destination_label: "Destination",
    destination_recentSearch: "Recent Searches",
    checkinDate_defaultDate: "7",
    checkinDate_label: "Check-in",
    checkinDate_datemask: "general",
    checkoutDate_defaultDate: "10",
    checkoutDate_label: "Check-out",
    checkoutDate_datemask: "general",
    maxDate: '400',
    dateRange: '90',
    addRoomLabel: 'Add more rooms',
    noAgeMessage: 'Select the age of each child to continue',
    roomLabel: 'Room {0}',
    confirmButton: 'Done',
    child12Message: 'Children under the age of 2 must travel with a guest aged 12 or older\n',
    interstitial: '',
    adultRange: '18 years and above',
    paxRoomLabel: '{0} Room',
    infantRange: 'Less than 2 years',
    child15Message: 'Children under the age of 15 must travel with an adult aged 18 or older\n',
    childRange: 'Between 2 to 17 years',
    moreRoomsWarning: 'Please make seperate bookings to book more than 1 room',
    addRoomMessage: 'You can add more rooms and guests on the next page',
    largeGroupMessage: 'You can book up to 6 guests at a time. Make separate bookings for larger groups. ',
    emptyChildMessage: 'Select the age of each child to continue',
    childAgeDropdownLabel: 'Child {0} age',
    placeHolderDestination: 'Try "Kuala Lumpur"',
    otherList: '',
    adult: 'Adult',
    removeRoom: 'Remove',
    suggestion_airport: 'Airport',
    suggestion_city: 'city',
    suggestion_landmark: 'Landmark',
    suggestion_neighborhood: 'Neighborhood',
    suggestion_region: 'Region',
    roomAndGuest: 'Room & guest'
  },
  config: {
    flybeyond: "TRUE"
  },
  origin: {
    apiDown: "We can't display the list of origin cities",
    originLabel: "From"
  },
  destination: {
    selectOriginFirst: "Select your origin city first",
    destinationLabel: "To",
    apiDown: "We can't display the list of destination cities",
    recentSearch: "Recent searches",
    popularDestination: "Destinations on sale"
  },
  main: {
    allAirport: "All airports",
    infant: "Infant",
    nearestAirport: "Nearest to you",
    adultRange: "12 years and above",
    placeHolderFlights: 'Try "Kuala Lumpur",Try "India",Try "DPS",Try "Phuket"',
    placeHolder: "Search by city, airport, or country",
    innerSearchHeadline: "Search SNAP packages",
    infantRange: "Under 2 years",
    paxDone: "Done",
    flyBeyondLabel: "Other airline",
    multiCity: "Multi-city",
    adult: "Adults",
    child: "Child",
    childRange: "2 to 11 years",
    search: "Search",
    apiDown: "We can't display the list of cities. Try again later.",
    errorCityIsNotCorrect: "We don't operate from this city",
    promoCode: "Promo code",
    noResults: "No results found",
    oneWayLabel: "One way",
    otherList: "{0} other cities",
    errorCityIsEmpty: "Select a city to continue",
    recentSelections: "Recent selections",
    allTerminal: "All terminals",
    editSearch: "Edit search"
  },
  departDate: {
    defaultDate: "7",
    datemask: "general",
    departLabel: "Depart date"
  },
  returnDate: {
    defaultDate: "10",
    datemask: "general",
    returnLabel: "Return date"
  },
  popularDestination: {
    datemask: "fullWithDay"
  },
  "calendar": {
    "reset": "Reset",
    "calendarTopLabel": "Select your depart date",
    "lowFareLabelFail": "Unable to display the lowest fares",
    "maxDate": "486",
    "lowFareLabelReturn": "Total: from {0}{1} return for 1 adult",
    "lowFareLabelOneWay": "Total: from {0}{1} one way for 1 adult",
    "lowFareLabelDefault": "Lowest all-in fares in {0} for 1 adult",
    "lowFareLabelLoading": "Loading our lowest fares",
    "returnRadio": "Return",
    "oneWayRadio": "One way",
    "ctaConfirm": "Confirm"
  },
  "accessibility": {
    "paxChildAdd": "You have {0} children. Add 1 child.",
    "navigationCombobox": "Browse cities by using the up and down arrows and select by pressing enter. Touch device users can browse cities with touching or swiping gestures.",
    "paxInfantAdd": "You have {0} infant. Add 1 infant.",
    "paxAdultAdd": "You have {0} adult. Add 1 adult.",
    "paxInfantRemove": "You have {0} infants. Remove 1 infant.",
    "paxYoungAdultAdd": "You have {0} teenagers. Add 1 teenager.",
    "paxYoungAdultRemove": "You have {0} teenagers. Remove 1 teenager.",
    "paxAdultRemove": "You have {0} adults. Remove 1 adult.",
    "paxChildRemove": "You have {0} children. Remove 1 child."
  },
  "error": {
    "promoCodeTooltip": "The promo code is either invalid or not applicable"
  },
  "channelID": {
    "mobileWeb": "98ba1fad5baab2959fd06259acc292c6ebf46e210735882afc32a084",
    "web": "906a14a4c039ea4af65874742638ddae5c3ec9c6bbc9026eea35f00f"
  },
  ctrip_url: "https://hotels.ctrip.com/hotels/list",
  popular_locations_in_china: [{
    country: "Beijing",
    ctrip_id: 178237
  }, {
    country: "Shanghai",
    ctrip_id: 180026
  }, {
    country: "Tianjin",
    ctrip_id: 3545
  }, {
    country: "Chongqing",
    ctrip_id: 853
  }, {
    country: "Dalian",
    ctrip_id: 1026
  }, {
    country: "Qingdao",
    ctrip_id: 3366
  }, {
    country: "Xi'an",
    ctrip_id: 3163
  }, {
    country: "Nanjing",
    ctrip_id: 6084436
  }, {
    country: "Suzhou",
    ctrip_id: 3353
  }, {
    country: "Xiamen",
    ctrip_id: 6084395
  }, {
    country: "Sanya",
    ctrip_id: 3346
  }, {
    country: "Taipei",
    ctrip_id: 3518
  }, {
    country: "Hongkong",
    ctrip_id: 184245
  }, {
    country: "Jinan",
    ctrip_id: 3491
  }, {
    country: "Wuhan",
    ctrip_id: 3835
  }, {
    country: "Ningbo",
    ctrip_id: 6084491
  }, {
    country: "Chengdu",
    ctrip_id: 930
  }, {
    country: "Hangzhou",
    ctrip_id: 6084457
  }, {
    country: "Shenzhen",
    ctrip_id: 3354
  }, {
    country: "Guangzhou",
    ctrip_id: 771
  }, {
    country: "Shenyang",
    ctrip_id: 3149
  }, {
    country: "Zhengzhou",
    ctrip_id: 6140608
  }],
  ctrip_origin_domain: 'airasia.cn',
  CN_LOCALE: 'zh-cn',
  CTRIP_FORMAT_DATE: "yyyy/MM/dd"
};
exports.DEFAULT_CONFIG = DEFAULT_CONFIG;
var _default = DEFAULT_CONFIG;
exports["default"] = _default;